import { TextField, InputAdornment, IconButton } from "@mui/material";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { WidgetProps } from "@rjsf/utils";
import { useRef } from "react";
import { inputStyles, renderLabel, renderDescriptionTooltip } from "./common";

// Time Widget for time-only input
export const TimeWidget = (props: WidgetProps) => {
  const { id, value, label, onChange, required, disabled, readonly, schema } = props;
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const val = event.target.value;
    if (val === "") {
      onChange(undefined);
      return;
    }
    onChange(val);
  };

  return (
    <TextField
      id={id}
      fullWidth
      type="time"
      value={value ?? ""}
      onChange={handleChange}
      disabled={disabled}
      inputRef={inputRef}
      slotProps={{
        input: {
          readOnly: readonly,
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                onClick={() => {
                  if (inputRef.current && "showPicker" in inputRef.current) {
                    (inputRef.current as any).showPicker();
                  }
                }}
                edge="end"
                size="small"
                sx={{ mr: schema.description ? 1 : 0 }}
              >
                <AccessTimeIcon fontSize="small" />
              </IconButton>
              {schema.description && renderDescriptionTooltip(schema.description)}
            </InputAdornment>
          ),
        },
        inputLabel: {
          shrink: true,
        },
      }}
      label={renderLabel(label, !!required)}
      required={required}
      size="small"
      variant="outlined"
      sx={inputStyles}
    />
  );
};
